import React from 'react';
import type { Event, EventHeroScopedProps } from '../../../../types/index';

export type HeroImageProps = {
    eventName: Event['name'];
} & Pick<
    EventHeroScopedProps,
    | 'croppedLogoUrl480'
    | 'croppedLogoUrl600'
    | 'croppedLogoUrl800'
    | 'croppedLogoUrl940'
>;

export const HeroImage = ({
    croppedLogoUrl480,
    croppedLogoUrl600,
    croppedLogoUrl800,
    croppedLogoUrl940,
    eventName,
}: HeroImageProps) => {
    return (
        <picture data-testid="hero-image">
            <source
                srcSet={`
                    ${croppedLogoUrl480} 480w,
                    ${croppedLogoUrl600} 600w,
                    ${
                        croppedLogoUrl940
                            ? `${croppedLogoUrl940} 940w`
                            : `${croppedLogoUrl800} 800w`
                    }
                `}
                sizes={`
                    (max-width:480px) 480px,
                    (max-width:600px) 600px,
                    ${croppedLogoUrl940 ? '940px' : '800px'}
                `}
            />
            <img
                width="600"
                height="300"
                alt={eventName}
                src={croppedLogoUrl600}
            />
        </picture>
    );
};
